import React, { useEffect, useState } from "react";
import { Box, Button, Grid2, Stack, Chip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import TableComponent from "components/grid";
import PaginationComponent from "components/ui-components/PaginationComponent";
import { useParams } from "react-router-dom";
import moment from "moment";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { IoMdSearch } from "react-icons/io";
import { useGetPendingMilestoneQuery } from "store/slices/apis/keyMilestoneSlice";
import { usePermission } from "hooks/usePermission";
import { MILESTONE_VIEW } from "config";
import { ReactComponent as CalendarIcon } from "assets/PwC_Funct_Icons_Calendar_Outline_Black_RGB.svg"

const columns = [
  {
    name: "Milestone ID",
    field: "milestone_number",
    renderer(params) {
      return (
        <Stack direction="row" spacing={1}>
          {params?.milestone_number && (
            <Chip
              label={params?.milestone_number}
              size="small"
              sx={{
                fontSize: "12px",
                "& .MuiChip-label": {
                  paddingLeft: "8px",
                  paddingRight: "8px",
                  fontWeight: 600,
                },
              }}
            />
          )}
        </Stack>
      );
    },
  },
  {
    name: "Milestone Name",
    field: "milestone_name",
  },
  // {
  //   name: "Created Date",
  //   field: "createdDate",
  //   renderer(params) {
  //     return (
  //       <>
  //         {params?.createdDate
  //           ? moment(params.createdDate).format("DD/MM/YY")
  //           : "N.A."}
  //       </>
  //     );
  //   },
  // },
  {
    name: "Plan Finish Date",
    field: "plan_date",
    renderer(params) {
      return (
        <>
          {params?.plan_date
            ? moment(params.plan_date).format("DD/MM/YY")
            : "N.A."}
        </>
      );
    },
  },
  {
    name: "Actual Finish Date",
    field: "actual_date",
    renderer(params) {
      return (
        <>
          {params?.actual_date
            ? moment(params.actual_date).format("DD/MM/YY")
            : "N.A."}
        </>
      );
    },
  },
  {
    name: "Workflow Status",
    field: "workFlowStatus",
  },
  // {
  //   name: "Action",
  //   field: "action",
  //   option: {
  //     view: true,
  //     delete: false,
  //     edit: false,
  //     acceptReject: true,
  //   },
  // },
];

const MilestoneSubmittedByMe = () => {
  const theme = useTheme();
  const mileStoneViewAccess = usePermission(MILESTONE_VIEW);
  const [pageNumber, setPageNumber] = useState(1);
  const { projectId } = useParams();
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [filters, setFilters] = useState({
    fromDate: "",
    toDate: "",
  });
  const {
    data: allMilestone,
    refetch,
    isLoading,
  } = useGetPendingMilestoneQuery({
    ProjectId: projectId,
    sortBy: "CreatedDate",
    sortOrder: "desc",
    from: filters?.fromDate,
    to: filters?.toDate,
    page: pageNumber,
    pageSize: 10,
  });
  let allMilestoneList = allMilestone?.data?.map((item) => {
    const parsedData = JSON.parse(item.data);
    const updatedParsedData = {
      ...parsedData,
      workFlowStatus: item?.status,
    };

    return {
      ...item,
      ...updatedParsedData,
    };
  });

  useEffect(() => {
    refetch();
  }, []);

  const CustomCalendarIcon = (props) => (
    <CalendarIcon {...props} style={{ width: 26, height: 26, fill:"#696969 ", stroke:"#696969", strokeWidth:4 }} />
  );

  return (
    <>
      <Grid2 container spacing={2} sx={{ mt: "20px" }}>
        <Grid2 size={12}>
          <Box
            sx={{
              display: "flex",
              alignItems: { xs: 'start', sm: 'center' },
              justifyContent: "space-between",
              flexDirection: { xs: 'column', sm: 'row' }
            }}
          >
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={2}
              sx={{
                // flexGrow: 2,
                alignItems: { xs: "stretch", sm: "center" },
                width: { xs: '100%', sm: 'auto' },
                "& .MuiStack-root": {
                  paddingTop: "15px",
                },
              }}
            >
              <LocalizationProvider dateAdapter={AdapterDayjs} size="small">
                <DemoContainer components={["DatePicker", "DatePicker"]}>
                  <DatePicker
                    label="From Date"
                    value={fromDate}
                    format="DD-MM-YYYY"
                    onChange={(newValue) => setFromDate(newValue)}
                     slots={{
                      openPickerIcon: CustomCalendarIcon,   
                    }}
                    slotProps={{
                      textField: {
                        sx: {
                          minWidth: 150,
                          "& .MuiOutlinedInput-input": {
                            padding: "10px",
                          },

                          "& .MuiInputLabel-root": {
                            top: "-6px",
                          },
                        },
                      },
                      field: {
                        clearable: true,
                        onClear: () =>
                          setFilters({
                            fromDate: "",
                            toDate: toDate
                              ? dayjs(toDate).format("YYYY-MM-DD")
                              : "",
                          }),
                      },
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker", "DatePicker"]}>
                  <DatePicker
                    label="To Date"
                    value={toDate}
                    format="DD-MM-YYYY"
                    clearable={true}
                    onChange={(newValue) => setToDate(newValue)}
                     slots={{
                      openPickerIcon: CustomCalendarIcon,   
                    }}
                    slotProps={{
                      textField: {
                        sx: {
                          minWidth: 150,
                          "& .MuiOutlinedInput-input": {
                            padding: "10px",
                          },

                          "& .MuiInputLabel-root": {
                            top: "-6px",
                          },
                        },
                      },
                      field: {
                        clearable: true,
                        onClear: () =>
                          setFilters({
                            fromDate: fromDate
                              ? dayjs(fromDate).format("YYYY-MM-DD")
                              : "",
                            toDate: "",
                          }),
                      },
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
              <Button
                loading={isLoading}
                onClick={() => {
                  setFilters({
                    fromDate: fromDate
                      ? dayjs(fromDate).format("YYYY-MM-DD")
                      : "",
                    toDate: toDate ? dayjs(toDate).format("YYYY-MM-DD") : "",
                  });
                }}
                size="large"
                startIcon={<IoMdSearch />}
                variant="outlined"
                sx={{
                  color: `${theme?.customSettings?.themeColor}`,
                  border: `1px solid ${theme?.customSettings?.themeColor}`,
                  background: "none",
                  textTransform: "inherit",
                  padding: "6px 20px",
                  marginTop: "12px !important",
                }}
              >
                Search
              </Button>
              <Button
                loading={isLoading}
                onClick={() => {
                  setFromDate(null);
                  setToDate(null);
                  const clearedValues = Object.fromEntries(
                    Object.keys(filters).map((key) => [key, ""])
                  );
                  setFilters(clearedValues);
                }}
                size="large"
                variant="outlined"
                sx={{
                  color: `${theme?.customSettings?.themeColor}`,
                  border: `1px solid ${theme?.customSettings?.themeColor}`,
                  background: "none",
                  textTransform: "inherit",
                  padding: "6px 15px",
                  marginTop: "12px !important",
                }}
              >
                Reset
              </Button>
            </Stack>
          </Box>
        </Grid2>
        <Grid2 size={12} sx={{ mt: 2 }}>
          <TableComponent
            columns={columns
              .map((col) =>
                col.field === "action"
                  ? {
                    ...col,
                    option: {
                      ...col.option,
                      view: mileStoneViewAccess,
                    },
                  }
                  : col
              )
              .filter((col) => {
                if (col.field !== "action") {
                  return true;
                } else {
                  return Object.values(col.option).some((v) => v === true);
                }

              })}
            data={allMilestoneList}
            isLoading={isLoading}
          />
          {!isLoading && (
            <Box sx={{ display: "flex", justifyContent: "end" }}>
              <PaginationComponent
                pageNumber={allMilestone?.pagination?.currentPage || 1}
                totalPages={allMilestone?.pagination?.totalPages || 1}
                onPageChange={setPageNumber}
              />
            </Box>
          )}
        </Grid2>
      </Grid2>
    </>
  );
};

export default MilestoneSubmittedByMe;
